/// <reference types="vite/client" />
import { parseEnv } from 'ht-sdk/web';
import z from 'zod';

const EnvSchema = z.object({
	VITE_NAME: z.string(),
	VITE_API_URL: z.string(),
	VITE_BASE_URL: z.string(),
	VITE_WEBSOCKET_URL: z.string(),
});

export const Env = parseEnv(import.meta.env, EnvSchema);
